module.exports = __webpack_public_path__ + "frxx/img/loop.27da76f.mp4";